import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  editLotteryBrand,
  getAllLotteryBrands,
} from "../../../../redux/features/lotteryBrand/lotteryBrandService";
import styles from "./index.module.css";
import Skeleton from "../../../../components/Skeleton";
import NoResultsFound from "../../../../components/NoResultsFound";
import Modal from "../../../../components/Modal";
import { showToast } from "../../../../components/ToastMsg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";

const LotteryBrands = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLotteriesLoading, lotteries } = useSelector(
    (state) => state.lottery.allLotteryBrands
  );

  const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
  const [selectedLotteryId, setSelectedLotteryId] = useState(null);
  const [selectedLotteryName, setSelectedLotteryName] = useState("");

  const closeDeactivationModal = () => setDeactivationModalOpen(false);

  const handleAddLottery = () => {
    navigate("create-new-lottery");
  };

  const handleEditLottery = (lotteryId) => {
    navigate(`edit-lottery/${lotteryId}`);
  };

  const fetchAllLotteries = useCallback(() => {
    dispatch(getAllLotteryBrands({}));
  }, [dispatch]);

  useEffect(() => {
    fetchAllLotteries();
  }, [fetchAllLotteries]);

  const handleDeactivate = async () => {
    setDeactivationModalOpen(false);
    try {
      const response = await dispatch(
        editLotteryBrand({ id: selectedLotteryId, status: false })
      ).unwrap();
      setSelectedLotteryId(null);
      showToast("success", response.message);
      fetchAllLotteries();
    } catch (error) {
      showToast("error", error.message);
    }
  };

  return (
    <div className={`card-section`}>
      <div className={`search-card`}>
        <div className={`search-card-header`}>
          <h1 className={`form-title ${styles.headDiv}`}>
            Lottery Brands{" "}
            <span
              className={`${styles.iocnDiv} ${styles.addBtn}`}
              onClick={handleAddLottery}
            >
              {" "}
              <FontAwesomeIcon icon={faPlus} color="#1D0C50" />
            </span>
          </h1>
        </div>
        <div className={`search-card-body`}>
          {isLotteriesLoading ? (
            <Skeleton
              columns={["Image", "Code", "Name", "Actions"]}
              rowCount={10}
              height={20}
            />
          ) : lotteries.length > 0 ? (
            <div className={`table-container`}>
              <table className={`table`}>
                <thead className={`thead`}>
                  <tr>
                    <th className={`theadColumnOne`}>Image</th>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody className={`tbody`}>
                  {lotteries?.map((lottery) => (
                    <tr key={lottery.id}>
                      <td className={`tdataColumnOne`}>
                        {" "}
                        <img
                          src={lottery.logo_url}
                          alt={`${lottery.name} Logo`}
                          className={styles.lotteryImage}
                        />
                      </td>
                      <td>{lottery.code}</td>
                      <td>{lottery.name}</td>
                      <td className={`actionsBtn`}>
                        <button className={styles.deleteButton}>
                          <FontAwesomeIcon
                            icon={faTrashAlt}
                            onClick={() => {
                              setSelectedLotteryId(lottery.id);
                              setSelectedLotteryName(lottery.name);
                              setDeactivationModalOpen(true);
                            }}
                            color="var(--danger)"
                          />
                        </button>
                        <button
                          className={styles.editButton}
                          onClick={() => handleEditLottery(lottery.id)}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <NoResultsFound />
          )}
        </div>
      </div>
      {isDeactivationModalOpen && (
        <Modal
          title="Lottery Deactivation"
          onClose={closeDeactivationModal}
          onYes={handleDeactivate}
          isInput={false}
          iconName={faCircleXmark}
          bodyText={`Are you sure you want to deactivate the Lottery Brand? ${selectedLotteryName}`}
          colorType={`var(--danger)`}
        />
      )}
    </div>
  );
};

export default LotteryBrands;
